import { render, staticRenderFns } from "./BaseDataTablePageSizeSelect.vue?vue&type=template&id=7ec540c4&scoped=true"
import script from "./BaseDataTablePageSizeSelect.vue?vue&type=script&lang=js"
export * from "./BaseDataTablePageSizeSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseDataTablePageSizeSelect.vue?vue&type=style&index=0&id=7ec540c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec540c4",
  null
  
)

export default component.exports